import axiosInstance from "./axios";

export class CarnetService {
    /**
     * Genera un reporte para un estudiante
     * @param {Object} estudianteDTO
     */
    generarReporte(estudianteDTO) {
        return axiosInstance
            .post(`/carnets/generarReporte`, estudianteDTO, { responseType: "blob" })
            .then((res) => res.data)
    }
}
